<div class="container pt-4 pb-5">
  <div class="container-shadow px-4">
    <div class="pt-4"></div>
    <h2>
      <div class="float-right">
        <small>
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="loadWords()">
            <i class="fas fa-redo" [ngClass]="{ 'fa-spin': loading }"></i>
          </button>
        </small>
      </div>
      Hunspell Spell Check - Custom dictionary list of words
    </h2>
    <hr />
    <div class="text-center py-5 my-5" *ngIf="loading">
      <i class="fas fa-spinner fa-fw fa-pulse fa-5x"></i>
    </div>
    <div *ngIf="!loading">
      <div class="row">
        <div class="col-sm-6">
          <table class="table table-sm">
            <thead>
              <tr>
                <b>Custom Words - </b>
                <app-badge badgeType="secondary">{{ words.length }}</app-badge>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let word of words">
                <td>
                  <div class="float-right">
                    &nbsp;
                    <button type="button" class="btn btn-sm btn-danger" [disabled]="removingWord" (click)="removeWord(word)"><i class="fas fa-times"></i></button>
                  </div>
                  {{ word }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label>Add word to dictionary</label>
            <div class="input-group">
              <input type="text" class="form-control" name="new_word" placeholder="add word" [(ngModel)]="newWord" (keyup.enter)="addWord()" />
              <div class="input-group-append">
                <button class="btn btn-primary" [disabled]="addingWord" (click)="addWord()">
                  <i class="fas fa-plus"></i>&nbsp; Add Word
                  <span *ngIf="addingWord">
                    &nbsp;
                    <i class="fas fa-spinner fa-fw fa-pulse"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pt-4"></div>
  </div>
</div>
